/**
 * Asserts that a given condition is true. If the condition is false, it throws an error with the provided message.
 *
 * @param condition - The condition to assert. If this evaluates to false, an error will be thrown.
 * @param message - The error message to throw if the assertion fails. This can be a string or a function that returns a string. Defaults to 'Assertion failed'.
 * @throws {Error} Throws an error if the condition is false.
 */
export function assert(
  condition: any,
  message: string | (() => string) = 'Assertion failed',
): asserts condition {
  if (condition) return;
  throw new Error(typeof message === 'function' ? message() : message);
}
